import React from "react";

import { Text } from "@UI/Components/Text/Text";
import { Flex } from "@UI/Components/Flex/Flex";
import { Bold } from "@UI/Components/Bold/Bold";
import { Rate } from "@Shared/Components/Rate/Rate";

import { FormattedNumber } from "@I18n/Components/FormattedNumber/FormattedNumber";
import {
  FormattedTimeUnit,
  FormattedTimeUnitProps,
} from "@I18n/Components/FormattedTimeUnit/FormattedTimeUnit";
import { IAppCurrency } from "@App/types";

interface FormatedPriceProps {
  preview?: boolean;
  priceCents: number;
  currency: IAppCurrency;
  billingUnit?: FormattedTimeUnitProps["unit"] | "flat";
  billingCount?: number;
  rateAmount?: number;
}

export const FormatedPrice = ({
  preview,
  priceCents,
  currency,
  billingUnit,
  billingCount,
  rateAmount,
}: FormatedPriceProps) => {
  if (preview) {
    return <Rate cents={priceCents} currency={currency} unit={billingUnit} />;
  } else {
    return (
      <Flex>
        <>
          {billingUnit !== "flat" && (
            <Text color="gray.500" m={0} mr={2} fontWeight="normal">
              ({billingCount}
              <FormattedTimeUnit unit={billingUnit} format="short" />
              {" x "}
              <FormattedNumber
                value={rateAmount}
                style="currency"
                currency={currency}
                minimumFractionDigits={0}
              />
              )
            </Text>
          )}
        </>
        <Bold>
          <Rate cents={priceCents} currency={currency} unit="flat" />
        </Bold>
      </Flex>
    );
  }
};
